// Shop the look images click event handle
const customShopTheLookImages = document.querySelectorAll('.custom-shop-the-look-image');

customShopTheLookImages.forEach(function (image) {
  image.addEventListener('click', function (event) {
    event.stopPropagation();
    const imageClicked = event.target,
      modalTarget = imageClicked.dataset.modal;

    if (modalTarget) {
      const modal = document.querySelector(modalTarget);
      if (modal) {
        modal.show(imageClicked);
      }
    }
  });
});

// Option select handler
const cardProductOptionSelect = document.querySelectorAll('.card-product-option-select');
cardProductOptionSelect.forEach(function (element) {
  // Fix make sure the select element can still be selected with draggable element
  element.addEventListener('mousedown', function (event) {
    event.stopPropagation();
  });

  // Change handler event for the variant change
  element.addEventListener('change', function (event) {
    
    const selectedOptionIndex = this.dataset.optionIndex,
      selectedBlockId = this.dataset.blockId,
      selectedProductId = this.dataset.productId,
      selectedValue = this.value;

    const cardProductAddToCartButton = document.querySelector('.custom-card-product-add-to-cart[data-block-id="' + selectedBlockId + '"][data-product-id="' + selectedProductId + '"]'),
      cardProductAddToCartButtonLabel = cardProductAddToCartButton.querySelector('span');

    if (selectedValue === '') {
      cardProductAddToCartButton.disabled = true;
      cardProductAddToCartButtonLabel.innerText = window.variantStrings.addToCart;
      return;
    }

    const selectedVariant = document.querySelector('input[name="custom-card-product-product-variants"][data-block-id="' + selectedBlockId + '"][data-product-id="' + selectedProductId + '"][data-option-' + 
      selectedOptionIndex + '-value="' + selectedValue + '"]');

    const cardProductSelectedProduct = document.querySelector('input[name="card-product-selected-product"][data-block-id="' + selectedBlockId + '"][data-product-id="' + selectedProductId + '"]');
    cardProductSelectedProduct.value = selectedVariant.dataset.variantId;
    cardProductSelectedProduct.dataset.available = selectedVariant.dataset.available;

    if (selectedVariant.dataset.available === 'true') {
      cardProductAddToCartButton.disabled = false;
      cardProductAddToCartButtonLabel.innerText = window.variantStrings.addToCart;
    } else {
      cardProductAddToCartButton.disabled = true;
      cardProductAddToCartButtonLabel.innerText = window.variantStrings.soldOut;
    }
  });
});

// Add to cart button handle
const cardProductAddTocartButton = document.querySelectorAll('.custom-card-product-add-to-cart');
cardProductAddTocartButton.forEach(function (button) {
  button.addEventListener('click', function (event) {
    const button = this;
    const buttonLabel = button.querySelector('span');
    const buttonIcon = button.querySelector('svg');
    button.disabled = true;
    buttonIcon.style.display = 'none';
    buttonLabel.innerText = window.customShopTheLookStrings.addToCartProcessing;

    const selectedProductId = this.dataset.productId;
    const selectedBlockId = this.dataset.blockId;
    // console.log('selectedProductId', selectedProductId);

    const cardProductSelectedProduct = document.querySelector('input[name="card-product-selected-product"][data-block-id="' + selectedBlockId + '"][data-product-id="' + selectedProductId + '"]');
    // console.log('cardProductSelectedProduct', cardProductSelectedProduct);
    if (cardProductSelectedProduct.dataset.available === 'true') {
      const addedVariantId = cardProductSelectedProduct.value;
      const url = window.Shopify.routes.root + 'cart/add.js'
      const data = {
        items: [{
          id: addedVariantId,
          quantity: 1
        }]
      };
      
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then(response => response.json())
      .then(data => {
        // this.disabled = false;
        if (data.status !== undefined) {
          console.error('Error:', data.message);
          buttonLabel.innerText = window.customShopTheLookStrings.addToCartError;
          setTimeout(function () {
            button.disabled = false;
            buttonLabel.innerText = window.variantStrings.addToCart;
            buttonIcon.style.display = 'block';
          }, 1500);
        } else {
          // Success
          buttonLabel.innerText = window.customShopTheLookStrings.addToCartSuccess;
          setTimeout(function () {
            button.disabled = false;
            buttonLabel.innerText = window.variantStrings.addToCart;
            buttonIcon.style.display = 'block';
          }, 1500);
  
          // Refresh cart after succesfully adding the product to the cart
          refreshCart();
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        buttonLabel.innerText = window.customShopTheLookStrings.addToCartError;
        setTimeout(function () {
          button.disabled = false;
          buttonLabel.innerText = window.variantStrings.addToCart;
          buttonIcon.style.display = 'block';
        }, 1500);
      });

    } else {
      if (cardProductSelectedProduct.dataset.available === 'true') {
        button.disabled = false;
        buttonLabel.innerText = window.variantStrings.addToCart;
      } else {
        button.disabled = true;
        buttonLabel.innerText = window.variantStrings.soldOut;
      }
      buttonIcon.style.display = 'block';
    }
  });
})

// Refresh cart item after product added to the cart
function refreshCart()
{
  const sectionIds = ['cart-drawer', 'cart-icon-bubble'];  
  const url = window.Shopify.routes.root + 'cart?sections=' + sectionIds.join(',');

  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  })
  .then(response => response.json())
  .then(data => {
    for (var sectionId in data) {
      if (data.hasOwnProperty(sectionId)) {
        const newHtml = data[sectionId];
        // const targetElement = sectionId === 'cart-drawer' ? document.getElementById('CartDrawer') : document.getElementById(sectionId);

        if (newHtml) {
          const newHtmlElement = new DOMParser().parseFromString(newHtml, 'text/html');

          if (sectionId === 'cart-icon-bubble') {
            const newHtmlElementDiv = newHtmlElement.querySelector('div');
            const targetElement = document.getElementById(sectionId);
            if (targetElement) {
              targetElement.innerHTML = newHtmlElementDiv.innerHTML;
            }
          } else {
            const newHtmlElementDiv = newHtmlElement.querySelector('#CartDrawer');
            const targetElement = document.getElementById('CartDrawer');
            if (targetElement) {
              targetElement.innerHTML = newHtmlElementDiv.innerHTML;
            }

            // Remove is-empty from cart-drawer element
            const cartDrawerElement = document.querySelector('cart-drawer');
            if (cartDrawerElement.classList.contains('is-empty')) {
              cartDrawerElement.classList.remove('is-empty');
            }
          }
        }
      }
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

